<template>
    <div v-if="!loading">
        <text-form-group
                v-model="data.headline"
                name="headline"
                label="Headline"
                :error="(errors.headline || [])[0]"
        />

        <div v-for="(user, index) in data.users" style="border: 1px solid black; border-radius: 15px; padding: 15px; margin-bottom: 15px">
            <select-form-group
                    v-model="user.id"
                    name="id"
                    label="User"
                    :options="userOptions"
            />

            <button type="button" class="btn btn-link btn-block" @click="removeUser(index)">
                <i class="fa fa-minus"/> Remove User
            </button>
        </div>

        <button type="button" class="btn btn-black btn-block" style="margin-bottom: 15px;" @click="addUser">
            <i class="fa fa-plus"/> Add User
        </button>
    </div>
</template>

<script>
    import http from '@/http'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {SelectFormGroup, TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        data() {
            return {
                users: null,

                loading: true
            }
        },

        mounted() {
            this.load()
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            },

            userOptions() {
                return this.users.map(user => ({value: user.id, label: user.attributes.full_name}))
            }
        },

        methods: {
            load() {
                http.get('/api/v2/users').then(response => {
                    this.users = response.data.data

                    this.loading = false
                })
            },

            addUser() {
                let users = this.data.users || []

                users.push({driver_parameters: {}})

                this.$emit('input', {...this.value, users})
            },

            removeUser(index) {
                let users = this.data.users || []

                users.splice(index, 1)

                this.$emit('input', {...this.value, users})
            }
        }
    }
</script>
